<template>
    <v-container>
        <v-row class="mb-n1">
            <v-col cols="12" md="6">
                <v-text-field
                    v-model="searchTerm"
                    label="Search"
                    placeholder="Search..."
                    outlined
                    clearable
                    dense
                    hide-details
                    :disabled="isLoading"
                    prepend-inner-icon="mdi-magnify"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
                <v-select
                    v-model="selectedSection"
                    :items="sections"
                    :disabled="isLoading"
                    label="Sections"
                    outlined
                    dense
                    clearable
                    hide-details
                ></v-select>
            </v-col>
            <v-col cols="12" md="3">
                <v-select
                    v-if="!hideStatus"
                    v-model="selectedStatus"
                    :items="statuses"
                    :disabled="isLoading"
                    label="Statuses"
                    outlined
                    dense
                    clearable
                    hide-details
                ></v-select>
            </v-col>
        </v-row>
        <v-data-table
            :headers="headers"
            :items="filteredMonsters"
            :items-per-page="15"
            dense
            class="elevation-1"
            :search="searchTerm"
            :footer-props="{
                showFirstLastPage: true,
                itemsPerPageOptions: [-1, 10, 15, 20, 25],
                firstIcon: 'mdi-arrow-collapse-left',
                lastIcon: 'mdi-arrow-collapse-right',
                prevIcon: 'mdi-minus',
                nextIcon: 'mdi-plus',
            }"
        >
            <template v-slot:[`item.name`]="{ item }">
                <router-link :to="{ name: 'readMonster', params: { id: item.keyId } }" :title="item.name">
                    {{ item.name ? item.name : `(NONE)` }}
                </router-link>
            </template>
        </v-data-table>
    </v-container>
</template>
<script>
import api from '@/api'
import { mapState } from 'vuex'
import { sortBy } from 'lodash'
export default {
    name: 'MonsterManual',
    data() {
        return {
            isLoading: false,
            searchTerm: null,
            headers: [
                {
                    text: 'Name',
                    align: 'start',
                    value: 'name',
                },
                {
                    text: 'Section',
                    align: 'start',
                    value: 'section',
                    width: '20%',
                },
                { text: 'Status', value: 'statusText', filterable: false, width: '15%' },
            ],
            monsters: [],
            sections: [],
            selectedSection: null,
            statuses: [
                { value: null, text: 'All' },
                { value: '0', text: 'Editing' },
                { value: '1', text: 'Submitted' },
                { value: '2', text: 'Flagged' },
                { value: '3', text: 'Approved' },
            ],
            selectedStatus: null,
        }
    },
    computed: {
        ...mapState(['user']),
        filteredMonsters() {
            let monsters = this.monsters
            if (this.selectedStatus != null) {
                monsters = monsters.filter(x => x.statusId == this.selectedStatus)
            }
            if (this.selectedSection) {
                monsters = monsters.filter(x => x.section == this.selectedSection)
            }
            return monsters
        },
    },
    mounted() {
        this.getMonster()
    },
    methods: {
        monsterSort(monsters) {
            return sortBy(monsters, ['section', 'name'])
        },
        getMonster() {
            if (this.isArchive) {
                this.getArchivedEntities()
                return
            }
            if (this.useEvents && this.selectedEvent === 0) return
            this.isLoading = true
            let apiUrl = `/monsters/monster-manual`
            api.get(apiUrl)
                .then(res => {
                    this.monsters = this.monsterSort(res)
                    let uniqueSections = [...new Set(res.map(x => x.section))].sort()
                    this.sections = uniqueSections
                    /* uniqBy(res, 'section').map(x => {
                        return { value: x.section, text: x.section }
                    })*/
                })
                .finally(() => (this.isLoading = false))
        },
    },
}
</script>
